import 'owl.carousel';
import { initSubjectCarousel } from '@components/sliders/sliders'

document.addEventListener('DOMContentLoaded', () => {
  initSubjectCarousel()
}, { once: true })
